<template>
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-sm-flex align-items-center justify-content-between">
        <h4 class="mb-sm-0">Rôle utilisateur</h4>

        <div class="page-title-right">
          <ol class="breadcrumb m-0">
            <li class="breadcrumb-item"><router-link :to="{ name: 'home' }">Administration</router-link></li>
            <li class="breadcrumb-item active">Rôle utilisateur</li>
          </ol>
        </div>

      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <form @submit.prevent="createRoleUser">
          <div class="card card-animate">

            <div class="card-body">
              <div class="row text-start">
                <div class="col-sm-12">
                  <label for="firstName" class="form-label">Nom</label>
                  <input v-model="roleUser.nom" type="text" class="form-control" required>
                  <div class="invalid-feedback">Veuillez entrer le nom</div>
                </div>
              </div>

              <div class="row text-start mt-3">
                <div class="col-sm-12">
                  <label for="firstName" class="form-label">Description</label>
                  <textarea v-model="roleUser.description" type="text" class="form-control" ></textarea>
                  <div class="invalid-feedback">Veuillez entrer la description</div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-12">
                  <div class="form-check form-switch form-switch-success">
                    <input  v-model="roleUser.enabled" class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" >
                    Active ?
                  </div>
                </div>
              </div>

            </div>
            <div class="card-footer">
              <div class="row">
                <button type="submit" class="btn btn-primary">Enregistrer</button>

              </div>
            </div>
          </div>

        </form>

      </div>
    </div>
  </div>
</template>

<script>
import Group from "@/entity/Group";
import Repository from '@/repository/RoleRepository'

export default {
  name: 'createRoleUserPage',
  data() {
    return {
      roleUser: new Group(),
      repository: new Repository(),

    }
  },
  computed: {
  },
  methods: {
    createRoleUser(){
      this.repository.create(this.roleUser);
      this.$router.push({ name: 'listRoles' })
    }
  },
  created() {

  }
}
</script>